import React from "react";
import { Link } from "react-router-dom";
import { PropertyGoo } from "../../components/PropertyGoo";
import { PropertyMoney } from "../../components/PropertyMoney";
import { PropertyNuts } from "../../components/PropertyNuts";
import { PropertySol } from "../../components/PropertySol";
import { PropertyTarget } from "../../components/PropertyTarget";
import { PropertyTwoCoins } from "../../components/PropertyTwoCoins";
import { PropertyWrapper } from "../../components/PropertyWrapper";
import { Tabs } from "../../components/Tabs";
import { Wallet } from "../../components/Wallet";
import { Iconify1 } from "../../icons/Iconify1";
import { Property1Variant7 } from "../../icons/Property1Variant7";
import { X6 } from "../../icons/X6";
import "./style.css";

export const StakeInSol = () => {
  return (
    <div className="stake-in-SOL">
      <div className="div-17">
        <div className="overlap-10">
          <div className="frame-459">
            <div className="frame-460">
              <div className="frame-461">
                <div className="group-155">
                  <div className="frame-462">
                    <div className="text-wrapper-253">Contract Power by TinySPL</div>
                  </div>
                </div>
                <div className="frame-463">
                  <p className="stake-to-mint-GOO-14">
                    <span className="text-wrapper-254">Stake to mint </span>
                    <span className="text-wrapper-255">$GOO</span>
                  </p>
                  <p className="text-wrapper-256">Stake today for earlier supporter airdrop🎁</p>
                </div>
              </div>
              <div className="frame-464">
                <div className="frame-465">
                  <div className="text-wrapper-257">Total GOO for Mint</div>
                  <div className="frame-466">
                    <div className="text-wrapper-258">10,000,000 GOO</div>
                  </div>
                </div>
                <div className="frame-467">
                  <div className="text-wrapper-257">Staking Period</div>
                  <div className="frame-466">
                    <div className="text-wrapper-258">3 Days</div>
                  </div>
                </div>
                <div className="frame-468">
                  <div className="text-wrapper-257">Total NUTS Staked</div>
                  <div className="frame-466">
                    <div className="text-wrapper-258">10,000 NUTS</div>
                  </div>
                </div>
                <div className="frame-469">
                  <div className="text-wrapper-257">Total SOL Staked</div>
                  <div className="frame-466">
                    <div className="text-wrapper-258">1,000 SOL</div>
                  </div>
                </div>
              </div>
              <div className="user-profile-8">
                <div className="nuts-8">
                  <PropertyNuts className="icons-57" image="/img/image-1-1.png" imageClassName="icons-58" />
                  <div className="element-16">
                    <div className="text-wrapper-257">Your Total Staked NUTS</div>
                    <div className="frame-466">
                      <div className="text-wrapper-258">100 NUTS</div>
                    </div>
                  </div>
                </div>
                <div className="sol-9">
                  <PropertySol className="icons-57" imageClassName="icons-59" />
                  <div className="element-17">
                    <div className="text-wrapper-257">Your Total Staked SOL</div>
                    <div className="frame-466">
                      <div className="text-wrapper-258">2 SOL</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="frame-470">
              <Tabs
                className="design-component-instance-node-5"
                img="/img/vector-10-1.svg"
                property1="tabs-tiers"
                vector="/img/vector-10.svg"
              />
              <div className="tiers-13">
                <div className="frame-471">
                  <div className="frame-472">
                    <div className="frame-473">
                      <div className="frame-474">
                        <PropertyGoo />
                        <PropertyNuts className="icons-60" image="/img/image-1-1-2x.png" />
                      </div>
                      <p className="div-18">
                        <span className="text-wrapper-259">Stake $NUTS for </span>
                        <span className="text-wrapper-260">Free $GOO Airdrop</span>
                      </p>
                    </div>
                    <div className="text-wrapper-261">0%</div>
                  </div>
                  <PropertyWrapper className="view-8" property1="one" />
                </div>
                <div className="frame-475">
                  <div className="frame-476">
                    <div className="frame-476">
                      <div className="frame-477">
                        <PropertyTarget />
                        <div className="frame-478">
                          <div className="text-wrapper-262">Hard Cap</div>
                          <div className="frame-479">
                            <div className="text-wrapper-263">Unlimited</div>
                          </div>
                        </div>
                      </div>
                      <div className="frame-477">
                        <PropertyTwoCoins />
                        <div className="frame-478">
                          <div className="text-wrapper-262">Amount of GOO</div>
                          <div className="frame-479">
                            <div className="text-wrapper-263">250,000 GOO</div>
                          </div>
                        </div>
                      </div>
                      <div className="frame-477">
                        <PropertyMoney iconify63StyleOverrideClassName="icons-61" />
                        <div className="frame-478">
                          <div className="text-wrapper-262">Price</div>
                          <div className="frame-479">
                            <div className="text-wrapper-263">Free</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Wallet
                    className="wallet-34"
                    divClassName="wallet-35"
                    property1="wallet-connect"
                    text="Stake Now"
                    visible={false}
                  />
                </div>
              </div>
              <div className="tiers-13">
                <div className="frame-471">
                  <div className="frame-480">
                    <div className="frame-481">
                      <div className="frame-474">
                        <PropertyGoo />
                        <PropertySol className="icons-60" />
                      </div>
                      <p className="div-18">
                        <span className="text-wrapper-259">Stake $SOL for </span>
                        <span className="text-wrapper-260">Whitelist Subscription </span>
                      </p>
                    </div>
                    <div className="text-wrapper-264">0%</div>
                  </div>
                  <PropertyWrapper className="view-8" property1="one" />
                </div>
                <div className="frame-475">
                  <div className="frame-476">
                    <div className="frame-476">
                      <div className="frame-477">
                        <PropertyTarget />
                        <div className="frame-478">
                          <div className="text-wrapper-262">Hard Cap</div>
                          <div className="frame-479">
                            <div className="text-wrapper-263">6,500 SOL</div>
                          </div>
                        </div>
                      </div>
                      <div className="frame-477">
                        <PropertyTwoCoins />
                        <div className="frame-478">
                          <div className="text-wrapper-262">Amount of GOO</div>
                          <div className="frame-479">
                            <div className="text-wrapper-263">3,500,000 GOO</div>
                          </div>
                        </div>
                      </div>
                      <div className="frame-477">
                        <PropertyMoney />
                        <div className="frame-478">
                          <div className="text-wrapper-262">Price</div>
                          <div className="frame-479">
                            <div className="text-wrapper-263">0.0185 SOL</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Wallet
                    className="wallet-34"
                    divClassName="wallet-35"
                    property1="wallet-connect"
                    text="Stake Now"
                    visible={false}
                  />
                </div>
              </div>
              <div className="tiers-13">
                <div className="frame-471">
                  <div className="frame-480">
                    <div className="frame-481">
                      <div className="frame-474">
                        <PropertyGoo />
                        <PropertySol className="icons-60" />
                      </div>
                      <p className="stake-NUTS-for-free-12">Stake $SOL for Public Subscription</p>
                    </div>
                    <div className="text-wrapper-264">0%</div>
                  </div>
                  <PropertyWrapper className="view-8" property1="one" />
                </div>
                <div className="frame-475">
                  <div className="frame-476">
                    <div className="frame-476">
                      <div className="frame-477">
                        <PropertyTarget />
                        <div className="frame-478">
                          <div className="text-wrapper-262">Hard Cap</div>
                          <div className="frame-479">
                            <div className="text-wrapper-263">3,500 SOL</div>
                          </div>
                        </div>
                      </div>
                      <div className="frame-477">
                        <PropertyTwoCoins />
                        <div className="frame-478">
                          <div className="text-wrapper-262">Amount of GOO</div>
                          <div className="frame-479">
                            <div className="text-wrapper-263">1,250,000 GOO</div>
                          </div>
                        </div>
                      </div>
                      <div className="frame-477">
                        <PropertyMoney />
                        <div className="frame-478">
                          <div className="text-wrapper-262">Price</div>
                          <div className="frame-479">
                            <div className="text-wrapper-263">0.0028 SOL</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Wallet
                    className="wallet-34"
                    divClassName="wallet-35"
                    property1="wallet-connect"
                    text="Stake Now"
                    visible={false}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="nav-20">
            <div className="nav-21">
              <div className="group-156">
                <div className="logo-15">
                  <div className="group-157">
                    <div className="frame-482">
                      <div className="group-158">
                        <div className="group-159">
                          <div className="ellipse-71" />
                        </div>
                        <div className="group-160">
                          <div className="ellipse-71" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="group-161">
                    <img className="group-162" alt="Group" src="/img/group-2.png" />
                    <div className="group-163">
                      <div className="ellipse-72" />
                    </div>
                    <div className="group-164">
                      <div className="ellipse-73" />
                    </div>
                    <div className="group-165">
                      <div className="overlap-group-17">
                        <div className="ellipse-74" />
                        <div className="rectangle-38" />
                      </div>
                    </div>
                    <img className="subtract-15" alt="Subtract" src="/img/subtract.svg" />
                    <div className="frame-483">
                      <div className="rectangle-39" />
                      <div className="ellipse-75" />
                    </div>
                  </div>
                </div>
                <div className="frame-484">
                  <div className="text-wrapper-265">Stake</div>
                  <div className="text-wrapper-266">About</div>
                  <div className="text-wrapper-267">Roadmap</div>
                  <div className="text-wrapper-268">Tokenomic</div>
                </div>
                <div className="frame-485">
                  <div className="frame-486">
                    <div className="twitter-13">
                      <X6 className="x-9" color="white" />
                    </div>
                    <img className="discord-15" alt="Discord" src="/img/discord.svg" />
                  </div>
                  <Wallet
                    className="wallet-36"
                    override={<Iconify1 className="iconify-1-instance" />}
                    phantomPhantomClassName="design-component-instance-node-5"
                    property1="phantom-wallet-connected"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <img className="rectangle-40" alt="Rectangle" src="/img/rectangle-19-1.svg" />
        <Link className="wallet-connect-6" to="/typing">
          <div className="frame-487">
            <div className="frame-488">
              <div className="frame-489">
                <div className="frame-490">
                  <div className="text-wrapper-269">Stake SOL</div>
                  <Property1Variant7 className="iconify-89" color="#202020" />
                </div>
              </div>
              <p className="please-note-you-can-3">
                <span className="text-wrapper-270">Please note, you can </span>
                <span className="text-wrapper-271">only stake once</span>
                <span className="text-wrapper-270"> for </span>
                <span className="text-wrapper-271">each tier</span>
              </p>
            </div>
          </div>
          <div className="frame-491">
            <div className="frame-492">
              <div className="frame-493">
                <div className="frame-494">
                  <div className="frame-495">
                    <div className="frame-496">
                      <div className="frame-497">
                        <div className="text-wrapper-272">My SOL:</div>
                        <div className="text-wrapper-273">2000</div>
                      </div>
                      <div className="frame-498">
                        <div className="text-wrapper-274">Minimum:</div>
                        <div className="text-wrapper-275">1 SOL</div>
                      </div>
                    </div>
                    <div className="frame-499">
                      <PropertySol className="icons-62" imageClassName="icons-63" />
                      <div className="frame-500">
                        <div className="text-wrapper-276">Enter NUTS Amounts</div>
                        <div className="text-wrapper-277">MAX</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="frame-501">
            <div className="frame-502">
              <div className="frame-493">
                <div className="frame-494">
                  <div className="frame-503">
                    <div className="frame-504">
                      <div className="text-wrapper-278">Stake SOL</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
};
